import React, { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Button } from 'antd';
import { View, Text } from 'react-native-web'
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import { LaptopOutlined, NotificationOutlined, UserOutlined, LogoutOutlined, CopyrightOutlined, PicCenterOutlined, CommentOutlined, PicLeftOutlined, DollarOutlined, BankOutlined, AuditOutlined, SmileOutlined, InfoCircleOutlined } from '@ant-design/icons';

import { Routes, Route, Navigate } from "react-router-dom";
import { store } from "../store";
import { server_var, themeColor } from "../config/servervar";
import { appLogout } from "../component/custom";

const { Header, Content, Sider } = Layout;

const menuList = ({ navigate, globalState, dispatch }) => {
  return [
    { id: 1, icon: PicCenterOutlined, label: 'Top Banner', path: '/topbanner' },
    { id: 2, icon: BankOutlined, label: 'Shop', path: '/shop' },
    { id: 3, icon: CommentOutlined, label: 'Consult', path: '/consult' },
    { id: 4, icon: NotificationOutlined, label: 'Notification', path: '/notification' },
    { id: 5, icon: UserOutlined, label: 'Staff', path: '/user' },
    { id: 6, icon: SmileOutlined, label: 'Customer', path: '/customer' },
    { id: 7, icon: InfoCircleOutlined, label: 'Infographic', path: '/infographic' },
    { id: 8, icon: LogoutOutlined, label: 'Logout', path: '/page3', onClick: () => appLogout(globalState, dispatch) }
  ].map(
    item => ({
      key: item.id.toString(),
      icon: React.createElement(item.icon),
      label: item.label,
      onClick: () => {
        if (item.onClick) {
          item.onClick()
        } else {
          navigate(item.path)
        }
      }
    }),
  );
}

export const ScreenLayout = () => {
  const navigate = useNavigate();
  const { globalState, dispatch } = useContext(store);

  useEffect(() => {
    if (globalState?.user) {
      navigate('/topbanner') // first menu item
    }
  }, [])
  
  if (globalState?.user) {
    return (
      <Layout style={{ height: '100vh' }}>
        <Layout>
          <Sider width={200} style={{ background: themeColor.color1, display: 'flex', flexDirection: 'column' }}>
            <div style={{
              flex: 1, height: 140,
              alignSelf: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'
            }}>
              <div style={{ padding: 10, backgroundColor: 'white', borderRadius: 10, marginTop: 20 }}>
                <img src="/logo192.png" style={{ width: 60, height: 60 }} />
              </div>
              <Text style={{ fontSize: 12, color: 'white', marginTop: 10, textAlign: 'center' }}>{'Prompt Health\nBackOffice'}</Text>
              <Text style={{ fontSize: 11, color: 'white', marginTop: 3, textAlign: 'center' }}>v.{server_var.version}</Text>

            </div>
            <Menu
              mode="inline"
              defaultSelectedKeys={['1']}
              defaultOpenKeys={['sub1']}
              style={{ borderRight: 0, backgroundColor: themeColor.color1, color: 'white', marginTop: 30 }}
              items={menuList({ navigate, globalState, dispatch })}
            />
          </Sider>
          <Layout style={{ padding: '0' }}>
            <Content
              style={{
                padding: 0,
                margin: 0,
                minHeight: 280,
              }}
            >
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    )
  } else {
    return <Navigate to="/login" replace />
  }

}
